/**
 * Reactive server-reachability signal. Updated by the axios interceptors from the
 * outcome of REAL requests (no background polling): a response — even an error status —
 * means the server is reachable; a request that resolves with no response (network error
 * / timeout) means it's offline. Components subscribe to reflect online/offline.
 */

let current = 'checking'; // 'checking' | 'online' | 'offline'
const listeners = new Set();

export function reportServerReachable(reachable) {
  const next = reachable ? 'online' : 'offline';
  if (next !== current) {
    current = next;
    listeners.forEach((fn) => {
      try { fn(current); } catch (e) { /* ignore listener errors */ }
    });
  }
}

export function getServerStatus() {
  return current;
}

export function subscribeServerStatus(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
